export default "__VITE_ASSET__C1li2hEE__"